import React, { Component } from 'react'
import { downloadQuoteSpecimenSubmission } from '../api'
import PDFLink from './GenerateLink'
import { toastify } from '../../components/shared/Toasts'
import ToastMessagesPdf from './ToastMessagesPdf'
import { getSubmission } from '../api'

class PDFPreviewQuoteSpecimen extends Component {
  constructor(props) {
    super(props)
    this.state = {
      error: {},
      pdfLink: '',
      loading: false,
    }
  }

  fetchQuotepdf = async () => {
    try {
      const response = await getSubmission(this.props.user, {
        id: this.props.submissionid,
      })
      let submissionObj = response?.data;
      let revisionNumber = submissionObj.revisionNumber;
      let autoGeneratedOrNonDeduct = true
      let isExcessSpecimen = false;
      let allPDF = []; 
      let singlePDF; 

      if (submissionObj.type === 'oi' && (submissionObj?.excessLimitAmount !== 'noExcess' && submissionObj?.excessLimitAmount !== undefined)) {
        isExcessSpecimen = true;
      }
      if (submissionObj?.coverages?.gl?.base === 'deductibleWarranty') {
        if (submissionObj.manuallySetPricing === 'true'
          || submissionObj.excessOnly === true) {
          autoGeneratedOrNonDeduct = false
        }
        if (submissionObj?.excessOnly !== true) {
          singlePDF = await downloadQuoteSpecimenSubmission(this.props.user, this.props.submissionid, true, true, false, revisionNumber)
          allPDF.push(singlePDF.data);
        }
        if (isExcessSpecimen) {
          singlePDF = await downloadQuoteSpecimenSubmission(this.props.user, this.props.submissionid, true, true, true, revisionNumber)
          allPDF.push(singlePDF.data);
        }
      }
      if (autoGeneratedOrNonDeduct) {
        if (submissionObj?.excessOnly !== true) {
          singlePDF = await downloadQuoteSpecimenSubmission(this.props.user, this.props.submissionid, true, false, false, revisionNumber)
          allPDF.push(singlePDF.data);
        }
        if (isExcessSpecimen) {
          singlePDF = await downloadQuoteSpecimenSubmission(this.props.user, this.props.submissionid, true, false, true, revisionNumber)
          allPDF.push(singlePDF.data);
        }
      }
      const allData = allPDF.join(',');
      if (allData && allData.length > 0) {
        this.setState({
            pdfLink: allData,
            loading: true
        });
      } else {
        throw 'PDF does not exist'
      }
    } catch (error) {
      console.log('error :: ', error)
      this.props.onHide();
      this.setState({
          loading: false
      });
      toastify.error(ToastMessagesPdf.failPdf);
    }
  };

  async componentWillMount() {
    this.fetchQuotepdf();
  }
  render() {
    return (
      <div>
        {
          <PDFLink
            custom_class={this.props.custom_class}
            pdfLink={this.state.pdfLink}
            show={this.props.show}
            onHide={this.props.onHide}
            loading={this.state.loading}
          />
        }
      </div>
    )
  }
}

export default PDFPreviewQuoteSpecimen
